"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Component = function () { return (react_1.default.createElement("svg", { width: "20", height: "13", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 1V0h20v1H0zm0 12v-1h20v1H0zm0-7v1h20V6H0z", fill: "#91908D" }))); };
exports.default = Component;
//# sourceMappingURL=MobileHamburger.js.map